module.exports = __webpack_public_path__ + "img/logo3.d7c27f15.png";